import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Link, Button } from 'formlabs-web-components/Link';
import { Grid, Cell, GridContainer } from 'formlabs-web-components/Grid';
import { Accordion, AccordionItem } from 'formlabs-web-components/Media';
import ListDropdown from './ListDropdown';

import './HeaderMenu.module.css';

class PageSubNav extends PureComponent {
  render() {
    const {
      slug,
      stuck,
      secondaryMenu,
      typeColor,
      mobile,
      storeMode,
      t
    } = this.props;
    const slugPath = slug ? slug.pathname : null;
    let options = [];
    let letterCount = 0;
    let button = null;
    const mobileTheme = typeColor === 'white' ? 'dark' : 'white';
    const visibleChildren = secondaryMenu.children.filter(
      menuItem => menuItem.visible
    );
    visibleChildren.forEach(item => {
      if (item.button === 'true') {
        return (button = item);
      } else {
        letterCount += item.name.length;
        options.push({ value: item.url, label: item.name });
      }
    });

    return (
      <div styleName={storeMode ? '' : 'page-sub-nav-container'}>
        {!mobile && (
          <Fragment>
            <div styleName={`holder ${stuck ? 'sticky-sub-holder' : ''}`} />
            <nav
              styleName={classnames(
                'page-sub-nav',
                `page-color-${stuck ? 'black' : typeColor}`,
                {
                  stuck,
                  'in-store': storeMode
                }
              )}
              aria-label={t('Second level page navigation')}
            >
              <GridContainer
                containerType={stuck || storeMode ? 'fluid' : 'full'}
              >
                <div
                  styleName={classnames('bottom-border', {
                    'hide-border': storeMode
                  })}
                >
                  <Grid
                    direction="x"
                    primaryAlignment="align-justify"
                    hasContainer={false}
                  >
                    <Cell mediumSize={4}>
                      <p styleName="page-title">{secondaryMenu.name}</p>
                    </Cell>
                    <Cell mediumSize={18}>
                      {letterCount < 70 && (
                        <ul
                          className="text-right"
                          styleName="page-sub-nav-right"
                        >
                          {visibleChildren.map(item => {
                            if (item.button === 'true') {
                              return (
                                <li styleName="sub-nav-item">
                                  <Button
                                    color="dark"
                                    to={item.url}
                                    key={item.url}
                                    styleName="sub-nav-button"
                                    noMargin={true}
                                  >
                                    {item.name}
                                  </Button>
                                </li>
                              );
                            } else {
                              return (
                                <li styleName="sub-nav-item">
                                  <Link
                                    to={item.url}
                                    title={item.name}
                                    styleName={classnames('sub-nav-link', {
                                      'current-page':
                                        item.url === slugPath || item.active
                                    })}
                                  >
                                    {item.name}
                                  </Link>
                                </li>
                              );
                            }
                          })}
                        </ul>
                      )}
                      {letterCount >= 70 && (
                        <div
                          className="text-right"
                          styleName="page-sub-nav-right"
                        >
                          <ListDropdown
                            children={visibleChildren}
                            title={secondaryMenu.name}
                          />
                          {button !== null ? (
                            <Button
                              color="dark"
                              to={button.url}
                              key={button.url}
                              styleName="sub-nav-button"
                            >
                              {button.name}
                            </Button>
                          ) : null}
                        </div>
                      )}
                    </Cell>
                  </Grid>
                </div>
              </GridContainer>
            </nav>
          </Fragment>
        )}{' '}
        {mobile && (
          <div
            styleName={classnames('page-sub-nav', { 'in-store': storeMode })}
          >
            <Accordion
              type="block-arrow"
              styleName={`${mobileTheme}-theme`}
              padding="medium"
              dark={mobileTheme === 'dark'}
            >
              <AccordionItem title={secondaryMenu.name}>
                <div styleName="page-sub-nav-right">
                  {visibleChildren.map(item => {
                    if (item.button === 'true') {
                      return (
                        <Button
                          color="dark"
                          to={item.url}
                          key={item.url}
                          styleName="sub-nav-button"
                        >
                          {item.name}
                        </Button>
                      );
                    } else {
                      return (
                        <div
                          styleName={`${
                            item.url === slugPath || item.active
                              ? 'current-page'
                              : ''
                          }`}
                          key={item.url}
                        >
                          <Link to={item.url}>{item.name}</Link>
                        </div>
                      );
                    }
                  })}
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        )}
      </div>
    );
  }
}
export default withTranslation()(PageSubNav);
